// extracted by mini-css-extract-plugin
var _1 = "group-GqCx7";
var _2 = "left-vwhEl";
var _3 = "quantity-bINRi";
var _4 = "right-Q4uQN";
export { _1 as "group", _2 as "left", _3 as "quantity", _4 as "right" }
